import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Keys, StorageService} from '../../service/storage.service';
import {Injectable} from '@angular/core';
import {ChannelPartnerService} from '../../service/channel-partner.service';

@Injectable()
export class ChannelPartnerIdResolver implements Resolve<void> {
    private readonly storageService: StorageService;
    private readonly channelPartnerService: ChannelPartnerService;

    constructor(storageService: StorageService, channelPartnerService: ChannelPartnerService) {
        this.storageService = storageService;
        this.channelPartnerService = channelPartnerService;
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<void> {
        const channelPartnerId = route.params !== undefined ? route.queryParams['channel-partner-id'] : undefined;
        if (channelPartnerId) {
            try {
                const partner = await this.channelPartnerService.getPartnerDetails(channelPartnerId);
                if (partner) {
                    this.storageService.saveObjectToSession(Keys.PARTNER_ID, channelPartnerId);
                }
            } catch (exception) {

            }
        }
    }
}
